import React, { useEffect } from 'react';

import toast from 'react-hot-toast';

import {
  promoTokenValidity,
  resetPromoTokenValidity,
  validatePromoToken,
} from '@pharmaplan/common';

import ToastNotification from '../../components/ToastNotification';
import genericClasses from '../../theme/GenericClasses';
import ThemeConstants from '../../theme/ThemeConstants';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';

const usePromoToken = () => {
  const dispatch = useAppDispatch();
  const isValid = useAppSelector(promoTokenValidity);

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  useEffect(() => {
    if (isValid?.isValid === false) {
      toast(
        (t) =>
          (
            <ToastNotification
              data={{ title: ' ', body: strings.invalidPromoMessage } as any}
              toastParams={t}
            />
          ),
        {
          duration: Infinity,
          style: {
            ...genericClasses.toastWidth,
            backgroundColor: ThemeConstants.common.priorityBg,
            borderLeft: `3px solid ${ThemeConstants.common.counterRed}`,
            color: ThemeConstants.common.grey850,
          },
        },
      );
      dispatch(resetPromoTokenValidity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid]);

  useEffect(() => {
    if (token) {
      dispatch(validatePromoToken(token ?? ''));
    }
  }, []);

  return {
    token,
  };
};

export default usePromoToken;
